"use client";
import { useCartStore } from "@/providers/cart-store-provider";
import { CartItem } from "@/stores/cart-store";
import { ArrowRightIcon } from "lucide-react";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { Button } from "./ui/button";

export const DateAddToCartButton = ({
  product,
  disabled,
  children,
}: {
  product: Omit<CartItem, "quantity">;
  disabled?: boolean;
  children?: React.ReactNode;
}) => {
  const addToCart = useCartStore((state) => state.addToCart);
  const cartItem = useCartStore((state) =>
    state.items.find((item) => item.databaseId === product.databaseId)
  );
  const pathname = usePathname();
  const isCheckout = pathname === "/kassan";

  return cartItem ? (
    <div className="flex items-center gap-2">
      {isCheckout ? (
        <QtyButtons
          databaseId={cartItem.databaseId}
          quantity={cartItem.quantity}
          available_quantity={product.available_quantity}
        />
      ) : (
        <Button
          effect="expandIcon"
          icon={ArrowRightIcon}
          iconPlacement="right"
          size="lg"
          asChild
          variant="default"
        >
          <Link className={`w-full`} href="/kassan" aria-label="Gå till kassan">
            Gå till kassan
          </Link>
        </Button>
      )}
    </div>
  ) : (
    <Button
      variant="defaultRed"
      effect="expandIcon"
      icon={ArrowRightIcon}
      iconPlacement="right"
      className={`h-[48px] ${
        product.available_quantity !== undefined &&
        product.available_quantity <= 0 &&
        "opacity-50 "
      }`}
      disabled={
        (product.available_quantity !== undefined &&
          product.available_quantity <= 0) ||
        disabled
      }
      onClick={() =>
        addToCart({
          ...product,
          quantity: 1,
        })
      }
    >
      {children}
    </Button>
  );
};

const QtyButtons = ({
  databaseId,
  quantity,
  available_quantity,
}: {
  databaseId: number;
  quantity: number;
  available_quantity?: number;
}) => {
  const incrementQuantity = useCartStore((state) => state.incrementQuantity);
  const decrementQuantity = useCartStore((state) => state.decrementQuantity);
  return (
    <div className="flex items-center">
      <button
        className="w-9 pb-2 pt-[0.7rem] border-2 border-primary-red rounded-l-md flex items-center justify-center uppercase bg-transparent font-josefin text-primary-red"
        onClick={() => decrementQuantity(databaseId, 1)}
      >
        -
      </button>
      <span className="text-[1rem] h-12 w-7 border-y-2 border-primary-red flex justify-center items-center bg-transparent text-primary-red font-josefin">
        {quantity}
      </span>
      <button
        className={`w-9 pb-2 pt-[0.7rem] border-2 border-primary-red rounded-r-md flex items-center justify-center uppercase bg-transparent font-josefin text-primary-red ${
          available_quantity !== undefined && quantity >= available_quantity
            ? "opacity-50 cursor-not-allowed"
            : ""
        }`}
        disabled={
          available_quantity !== undefined && quantity >= available_quantity
        }
        onClick={() => incrementQuantity(databaseId, 1)}
      >
        +
      </button>
    </div>
  );
};
